import { IPromise } from 'angular'
import { ApiChannel, ChannelType } from '@vend/types'
import { $q } from '../../ng-compat/imports'
import { EntityStore } from './entity-store'

class ChannelsStore extends EntityStore<'channels'> {
  constructor() {
    'ngInject'
    super({
      entityStoreName: 'channels',
      entityName: 'channels',
    })
  }

  /**
   * Get channels from the store that match given channel type.
   *
   * @param channelType
   *          The type of the channel to retrieve
   *
   * @return A promise resolved with the requested channel details
   */
  public getByChannelType(channelType: ChannelType): IPromise<ApiChannel[]> {
    return $q.resolve(this.dbStore.index('byChannelType').getAll(channelType))
  }
}

export const channelsStore = new ChannelsStore()
